<template>
  <VFilters
    v-if="!loading"
    :allowed-filters="allowedFilters"
    :filter-groups="filterGroups"
    :default-filters="$route.query.filter || {}"
  />
</template>

<script>
import { accountAssetTagsClient } from '@/api/clients';
import VFilters from '@/components/Common/VFilters.vue';

export default {
  name: 'AccountAssetFilters',
  components: {
    VFilters,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tagOptions: [],
      allowedFilters: {},
      filterGroups: {
        tag: {
          label: 'tag',
          name: 'tag',
          filters: ['has_tags', 'doesnt_have_tags', 'tags_in', 'tags_not_in'],
          value: 'tags_in',
        },
      },
    };
  },

  async created() {
    try {
      this.loading = true;
      await this.loadTagOptions();

      this.allowedFilters = {
        has_tags: {
          label: 'with',
          multiple: false,
          name: 'has_tags',
          type: Number,
          value: 1,
        },
        doesnt_have_tags: {
          label: 'without',
          multiple: false,
          name: 'has_tags',
          type: Number,
          value: 0,
        },
        tags_in: {
          label: 'is one of ...',
          multiple: true,
          name: 'tags_in',
          options: this.tagOptions,
          type: Number,
          value: [],
        },
        tags_not_in: {
          label: 'is not one of ...',
          multiple: true,
          name: 'tags_not_in',
          options: this.tagOptions,
          type: Number,
          value: [],
        },
      };
    } catch (error) {
      //
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async loadTagOptions() {
      try {
        const result = await accountAssetTagsClient.list(this.accountId);

        this.setTagOptions(result.data.data);
      } catch (error) {
        //
      }
    },
    setTagOptions(tags) {
      this.tagOptions = tags.map((tag) => ({
        label: tag.name,
        value: tag.id,
      }));
    },
  },
};
</script>
